import {ISelectItem} from '~/components/Controls/Select';

export enum PerformanceType {
    SUMMARY = 'summary',
    COUNTRY = 'country',
    AD_TYPE = 'adType',
    PLATFORM = 'platform',
    PAYER = 'payer',
    SELLER = 'seller',
    AGENCY = 'agency'
}

export enum Granularity {
    HOUR = 'hour',
    DAILY = 'day',
    WEEK = 'week',
    MONTH = 'month'
}

export const granularities: ISelectItem<Granularity>[] = [
    {value: Granularity.HOUR, label: 'Hourly'},
    {value: Granularity.DAILY, label: 'Daily'},
    {value: Granularity.WEEK, label: 'Weekly'},
    {value: Granularity.MONTH, label: 'Monthly'},
];

export interface IPerformanceDimension {
    value: any;
    label: string;
}

export type IPerformance = {
    timestamp: string;
    spent: number;
    adRequests: number;
    impressions: number;
    clicks: number;
    finishes: number;
    ctr: number;
    ecpm: number;
    sspIncome: number;
    exchangeFee: number;
    exchangeFeePercentage: number;
    fee: number;
    errors: number;
    lostImpressions: number;
    lostImpressionsRevenue: number;
    country?: IPerformanceDimension;
    adType?: IPerformanceDimension;
    platform?: IPerformanceDimension;
    agency?: IPerformanceDimension;
    seller?: IPerformanceDimension;
    payer?: string;
    isPaas?: boolean;
    demandPartner?: string;
};
